<template>
  <section>
    <ai-advert-generation-settings />
  </section>
</template>

<script>
import AiAdvertGenerationSettings from '@/settings/components/AiAdvertGenerationSettings.vue'

export default {
  name: 'AiSettings',
  components: {
    AiAdvertGenerationSettings
  }
}
</script>
